module.exports = __webpack_public_path__ + "img/i_media_matrix-3.37a596b3.png";